/* Formatting helpers. Date helpers accept Firestore Timestamp | ISO string |
   Date | millis so callers don't have to normalise first. */

export function toDate(v) {
  if (!v) return null;
  if (typeof v.toDate === "function") return v.toDate(); // Firestore Timestamp
  if (v instanceof Date) return v;
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
}

export function formatRelative(value) {
  const d = toDate(value);
  if (!d) return "—";
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return Math.floor(diff / 60) + " min ago";
  if (diff < 86400) return Math.floor(diff / 3600) + " hours ago";
  if (diff < 86400 * 7) return Math.floor(diff / 86400) + " days ago";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatDate(value, opts = { year: "numeric", month: "short", day: "numeric" }) {
  const d = toDate(value);
  return d ? d.toLocaleDateString("en-US", opts) : "—";
}

export function formatDateTime(value) {
  const d = toDate(value);
  return d ? d.toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "—";
}

export const CURRENCY_FMT = (amount, currency = "GHS") =>
  `${currency} ${Number(amount || 0).toLocaleString()}`;

export function slugify(str) {
  return (str || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/* Value for an <input type="datetime-local"> from any date-ish value. */
export function toDatetimeLocal(value) {
  const d = toDate(value);
  if (!d) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
